import { siteidOverrides } from './siteid';
import { brandidOverrides } from './brand';
import { defaultConfig } from './default-config';
import { IStaticConfig } from './typings';

let config: IStaticConfig = null;

export const getStaticConfig = (siteID: number, brandID: string = null): IStaticConfig => {
  config = {
    ...defaultConfig,
    ...siteidOverrides[`siteid${siteID}`],
    ...brandidOverrides[`brand${brandID}`],
    changeSearch : {
      ...defaultConfig.changeSearch,
      ...(siteidOverrides[`siteid${siteID}`]?.changeSearch || {}),
      ...(brandidOverrides[`brand${brandID}`]?.changeSearch || {})
    },
    environment : {
      ...defaultConfig.environment,
      ...(siteidOverrides[`siteid${siteID}`]?.environment || {}),
      ...(brandidOverrides[`brand${brandID}`]?.environment || {})
    }
  };

  return config;
};
